import { c as _c } from "react/compiler-runtime";
import { BodyShort } from '@navikt/ds-react';
import { OrganisasjonMedState } from '../Virksomhetsvelger/useTastaturNavigasjon';
import { formatOrgNr } from '../Virksomhetsvelger/util';
import styles from './Hovedenhet.module.css';
export const Hovedenhet = t0 => {
  const $ = _c(15);
  const {
    hovedenhet,
    antallUnderenheter
  } = t0;
  const valgt = hovedenhet.underenheter.some(_temp);
  let t1;
  if ($[0] !== hovedenhet.navn) {
    t1 = <BodyShort className={styles.hovedenhetTittel}>{hovedenhet.navn}</BodyShort>;
    $[0] = hovedenhet.navn;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span>Org.nr. </span>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== hovedenhet.orgnr) {
    t3 = formatOrgNr(hovedenhet.orgnr);
    $[3] = hovedenhet.orgnr;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <BodyShort>{t2}<span>{t3}</span></BodyShort>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = antallUnderenheter === 1 ? "underenhet" : "underenheter";
  const t6 = valgt ? " - 1 valgt" : "";
  let t7;
  if ($[7] !== antallUnderenheter || $[8] !== t5 || $[9] !== t6) {
    t7 = <BodyShort className={styles.hovedenhetBeskrivelse}>{antallUnderenheter} {t5}{t6}</BodyShort>;
    $[7] = antallUnderenheter;
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t1 || $[12] !== t4 || $[13] !== t7) {
    t8 = <div className={`${styles.hovedenhet} ${styles.hovedenhetJuridisk}`}><div className={styles.hovedenhetTekst}>{t1}{t4}{t7}</div></div>;
    $[11] = t1;
    $[12] = t4;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
};
function _temp(underenhet) {
  return underenhet.valgt;
}